import React, { useState, useEffect } from 'react'

// redux
import { connect } from 'react-redux'

// bootstrap
import {
    Container
} from 'react-bootstrap'


// products styles
import "./styles/products-styles.scss"

// products table
import ProductsTableTopBar from './includes/ProductsTable/ProductsTableTopBar'
import ProductsTable from './includes/ProductsTable/ProductsTable'

// react toastify
import { toast } from 'react-toastify';

// APIs
import { getProducts, deleteProduct, handleProductStatusChangeApi } from 'utlis/Apis/Products_API'

// section loading
import SectionLoading from 'utlis/helpers/SectionLoading/SectionLoading'

// pagination
import Pagination from 'components/CommonComponents/Pagination'

// common healpers
import { debounce } from 'utlis/helpers/Common/CommonHelperFunctions'

// custom hooks
import useQuery from 'utlis/CustomHooks/useQueryHook'

// app messages
import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME,
    ERROR_WHILE_FETCHING_PRODUCTS,
    ERROR_WHILE_DELETING_PRODUCTS,
    CONFIRMATION_BEFORE_DELETING_PRODUCT,
    PRODUCT_DELETED_SUCCESSFULLY,

    PRODUCT_STATUS_CHANGED_SUCCESSFULLY
} from 'utlis/AppMessages/AppMessages'

import { setGlobalLoading } from 'redux/actions/actionCommon'
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl'

function Products(props) {
    // props
    const { authState, setGlobalLoading } = props

    // consts
    const loadingCount = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

    // store url
    const [storeUrl] = useStoreUrl()

    // states
    const [products, setProducts] = useState([])
    const [productsImages, setProductsImages] = useState({})
    const [loading, setLoading] = useState(true)

    const [allCheckboxSelected, setAllCheckboxesSelected] = useState(false)
    const [paginationLinks, setPaginationLinks] = useState([])

    const [column__ProductName, setColumn__ProductName] = useState(true)
    const [column__ProductImg, setColumn__ProductImg] = useState(true)
    const [column__ProductSKU, setColumn__ProductSKU] = useState(true)
    const [column__ProductStatus, setColumn__ProductStatus] = useState(true)
    const [column__ProductStock, setColumn__ProductStock] = useState(true)
    const [column__ProductPrice, setColumn__ProductPrice] = useState(true)

    const [sectionLoadingVisible, setSectionLoadingVisible] = useState(false)

    const [searchQuery, setSearchQuery] = useState("")

    let query = useQuery();
    let page = query.get('page')
    let keyword = query.get('keyword')

    // useEffect: getting products data
    useEffect(() => {

        // generating url parameters
        let URLParams = `${(keyword) ? "keyword=" + keyword + "&" : ""}${page ? "page=" + page : ""}&show_disabled=1&limit=50`

        // enabling loading types based on the data present or not
        // enabling section loading
        setSectionLoadingVisible(true)

        // getting data
        if (!props.currentUser)
            return

        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getProducts(headers, URLParams).then(res => {
            // disabling section loading & loading
            setSectionLoadingVisible(false)
            setLoading(false)

            const resData = res.data

            // scroll the page to the top
            window.scrollTo(0, 0)

            // if request succesfull
            if (resData && resData.success) {
                // setting pagination links
                setPaginationLinks(resData.links)

                // settings products
                setProducts(resData.data)

                // settings images
                const imagedObj = resData.images
                setProductsImages(imagedObj)
            }

            // if request is not succesfull
            if (resData && resData.error) {
                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(ERROR_WHILE_FETCHING_PRODUCTS, {
                    autoClose: 3000,
                    onClose: () => {
                        // disabling loading
                        setLoading(false)
                    }
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getProducts `, err.message)

            // dismissing all the previous toasts first
            toast.dismiss();

            // showing the error message
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    // disabling section loading & loading
                    setSectionLoadingVisible(false)
                    setLoading(false)
                }
            })
        })
    }, [keyword, page, props])

    // selecting all the columns
    const handleSelectAllChange = (ev) => {
        const checkboxes = document.getElementsByClassName('all-checkboxes-selector-checkbox')

        // checking the checkbox and selecting all the checkboxes
        setAllCheckboxesSelected(!allCheckboxSelected)
        setTimeout(() => {
            if (ev.target.checked) {
                // all checkboxes selected
                checkboxes.length && Array.from(checkboxes).forEach(checkbox => {
                    checkbox.checked = true
                });
            } else {
                // all checkboxes not selected
                checkboxes.length && Array.from(checkboxes).forEach(checkbox => {
                    checkbox.checked = false
                });
            }
        }, 50);
    };

    // deleting
    const handleDelete = (ev, prodId) => {
        ev.preventDefault()
        var confirmation = window.confirm(CONFIRMATION_BEFORE_DELETING_PRODUCT)

        if (confirmation) {
            // enabling the section loading
            setSectionLoadingVisible(true)
            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            // deleting data from the api
            deleteProduct(headers, prodId).then(res => {
                // disabling the section loading
                setSectionLoadingVisible(false)

                const deletedData = res.data
                // if delete succesfully
                if (deletedData.success) {
                    // updating products state after deleting an products.
                    const filteredList = products.filter(item => item.product_id !== prodId)

                    // settings updated products
                    setProducts(filteredList)

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.success(PRODUCT_DELETED_SUCCESSFULLY, {
                        autoClose: 2500,
                    })
                }

                // if some error while deleting
                if (deletedData.error) {
                    console.log(ERROR_WHILE_DELETING_PRODUCTS, res)
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(ERROR_WHILE_DELETING_PRODUCTS, {
                        autoClose: 2500,
                    })
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} deleteProduct `, err.message)

                // disabling the section loading
                setSectionLoadingVisible(false)

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                })
            })
        }
    }


    // searching
    const handleSearchChange = debounce(ev => {
        let searchQueryValue = ev.target.value

        // enabling section loading
        setSectionLoadingVisible(true)

        // if serch query has length
        if (searchQueryValue && searchQueryValue.length) {
            // setting search query data
            setSearchQuery(searchQueryValue)

            // redirecting to products with search data
            props.history.push(`${storeUrl}/catalog/products?keyword=${searchQueryValue}&page=1`)
        }

        // if serch query does not have length
        if (!searchQueryValue) {
            // setting search query data
            setSearchQuery("")

            // redirecting to products with search data
            props.history.push(`${storeUrl}/catalog/products?page=1`)
        }
    }, 500)

    // product status chagne
    const handleProductStatusChange = (ev, product_id) => {
        const inpVal = ev.target?.checked

        if (product_id) {
            // section loading
            setSectionLoadingVisible(true)

            // required data
            const requiredData = {
                product_id,
                status: inpVal ? 1 : 0
            }
            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            // network requrest
            handleProductStatusChangeApi(headers, requiredData).then(res => {
                // section loading
                setSectionLoadingVisible(false)

                const resData = res.data

                // scroll the page to the top
                window.scrollTo(0, 0)

                // if request succesfull
                if (resData?.success) {
                    const copyOfProducts = [...products]
                    const filterList = copyOfProducts.map(item => {
                        if (item.product_id === product_id) {
                            return {
                                ...item,
                                is_disabled: inpVal ? 1 : 0
                            }
                        }
                        return item
                    })
                    // updating the products list
                    setProducts(filterList)

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.success(PRODUCT_STATUS_CHANGED_SUCCESSFULLY, {
                        autoClose: 2500,
                        onClose: () => {
                            // disabling loading
                            setLoading(false)
                        }
                    })
                }

                // if request is not succesfull
                if (resData?.error) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500,
                        onClose: () => {
                            // disabling loading
                            setLoading(false)
                        }
                    })
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} handleProductStatusChange `, err.message)

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // section loading
                        setSectionLoadingVisible(false)
                    }
                })
            })
        }
    }

    return (
        <section id="app-products" className="st-def-mar-TB">
            <Container fluid className="st-container">
                <div className="app-products">
                    {/* HEADING WRAPPER */}
                    <div className="app-header-wrapper d-flex mb-2">
                        {/* heading */}
                        <p className="app-heading text-capitalize">Products</p>
                    </div>

                    {/* CONTENT WRAPPER */}
                    <div className="app-content-container">
                        {/* app card */}
                        <div className="app-card">
                            <div className="app-card-content bg-white border st-border-light st-default-rounded-block mb-3">
                                {/* top bar */}
                                <div className="acc_top-bar border-bottom st-border-light">
                                    <ProductsTableTopBar
                                        parentProps={props}

                                        column__ProductName={column__ProductName}
                                        column__ProductImg={column__ProductImg}
                                        column__ProductSKU={column__ProductSKU}
                                        column__ProductStatus={column__ProductStatus}
                                        column__ProductStock={column__ProductStock}
                                        column__ProductPrice={column__ProductPrice}

                                        setColumn__ProductName={setColumn__ProductName}
                                        setColumn__ProductImg={setColumn__ProductImg}
                                        setColumn__ProductSKU={setColumn__ProductSKU}
                                        setColumn__ProductStatus={setColumn__ProductStatus}
                                        setColumn__ProductStock={setColumn__ProductStock}
                                        setColumn__ProductPrice={setColumn__ProductPrice}

                                        handleSearchChange={handleSearchChange}
                                    />
                                </div>

                                {/* table */}
                                <div className="st-listing-table products-table">
                                    <ProductsTable
                                        parentProps={props}

                                        allCheckboxSelected={allCheckboxSelected}
                                        handleSelectAllChange={ev => handleSelectAllChange(ev)}

                                        column__ProductName={column__ProductName}
                                        column__ProductImg={column__ProductImg}
                                        column__ProductSKU={column__ProductSKU}
                                        column__ProductStatus={column__ProductStatus}
                                        column__ProductStock={column__ProductStock}
                                        column__ProductPrice={column__ProductPrice}

                                        handleProductStatusChange={(ev, product_id) => handleProductStatusChange(ev, product_id)}

                                        loadingCount={loadingCount}
                                        loading={loading}

                                        products={products}
                                        productsImages={productsImages}

                                        handleDelete={(ev, id) => handleDelete(ev, id)}
                                    />

                                    {
                                        /* SECTION LOADING */
                                        sectionLoadingVisible && (
                                            <SectionLoading />
                                        )
                                    }
                                </div>
                            </div>

                            {/* paginations */}
                            <div className="pagination-container d-flex justify-content-end">
                                <Pagination
                                    searchQuery={searchQuery}
                                    routeName={storeUrl + "/catalog/products"}
                                    paginationLinks={paginationLinks}
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </Container>
        </section>
    )
}


const getDataFromStore = state => {
    return {
        authState: state.auth,
        currentUser: state.auth.currentUser
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: (bool) => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(Products)